// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c1278de","239":"3cb002aa","488":"0a5ddeda","732":"7cb28912"}[chunkId] + ".chunk.js";
};